import { GetServerSideProps, GetServerSidePropsContext, NextPage } from 'next';
import React from 'react';
import { ErrorPage } from '../page-components/error/ErrorPage';
import Config from '../config';
import { getServerSideSitemap, getServerSideSitemapIndex, ISitemapField } from 'next-sitemap';

const Page: NextPage<any> = () => {
  return <ErrorPage code={404} />;
};

export default Page;

const handleSitemap = async (ctx: GetServerSidePropsContext, fileName: string) => {
  console.log('Fetching sitemap json: ', fileName);
  const data = await (await fetch(`${Config.fileStoreUrl}/files/sitemap/${fileName}.json`)).json();
  console.log('Fetched sitemap json: ', JSON.stringify(data));
  if (data.type === 'index') {
    console.log('Creating serverside sitemapindex');
    return getServerSideSitemapIndex(
      ctx,
      data.files.map((f: string) => `${Config.frontendUrl}/${f}.xml`),
    );
  } else if (data.type === 'sitemap') {
    const fields: ISitemapField[] = data.paths.map((path: { loc: string; lastmod: string }) => ({
      loc: `${Config.frontendUrl}/${path.loc}`,
      lastmod: path.lastmod,
    }));
    console.log('Creating serverside sitemap:', JSON.stringify(fields));
    return getServerSideSitemap(ctx, fields);
  }
  return { props: {} };
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const slug: string = (ctx?.query?.slug ?? '') as string;
  if (Config.seoEnabled && slug.split('.')[1] === 'xml' && slug.indexOf('sitemap') !== -1) {
    try {
      return await handleSitemap(ctx, slug.split('.')[0]);
      // eslint-disable-next-line no-empty
    } catch (e) {}
  }
  return { props: {} };
};
